import {API_URLS} from "../constants/urls";
import {setUrl} from "../utils/urls";
import { getErrorCode } from "../utils/errors";

const otpRegex = new RegExp(/.*(verify).*OTP.*/);
const isVerifyOTPError = (error) => otpRegex.test(error?.config?.url);

export const responseErrorInterceptor = (error) => {

  const errorCode = getErrorCode(error);
  if(error?.response?.status === 401 && !isVerifyOTPError(error) && errorCode !== "IAM_ERR_005" && errorCode !== "IAM_ERR_037") {
    setUrl("", API_URLS.SIGNIN)
  }

  return error;
}